/* Displays the icon based on the document type/function */
import React from "react";
import { DocumentType } from "../../../types/DocumentType";
import { DocumentTypeIcon } from "../../../components/utilities";
import { ClientDocumentsTableRowColumn } from "./ClientDocumentsTableRowColumn";

export const ClientDocumentsTableRowTypeColumn = ({
    data,
    width
} : Readonly<{
    data: DocumentType,
    width: number | string
}>) => (
    <ClientDocumentsTableRowColumn className="text-center" width={width}>
        <DocumentTypeIcon description={data.typeDescription} documentType={data.documentType} />
    </ClientDocumentsTableRowColumn>
);